export const PLAN_CODES = {
	Basic: { Monthly: '0', Yearly: '0' },
	Pro: { Monthly: '799', Yearly: '7999' },
	Enterprise: { Monthly: '2499', Yearly: '24999' }
};
